import ApplicationController from '../../support/application_controller'
import interpolate from '../../lib/nitrous/interpolate'

export default class extends ApplicationController {

  static targets = [
    'document'
  ]

  documentTargetConnected() {
    this.documentTargets.forEach((target, index) => {
      interpolate(target, { index })
    })
  }

}
